import { AUTOSWAP_OP, AUTOSWAP_STABLES } from '$lib/settings';
import type { TokenInfo, TokenSymbol } from '$lib/types/tokens';
import { derived, type Readable } from 'svelte/store';

export let tokensAllowedForWithdraw: Array<TokenSymbol> = [
	'sUSD',
	'OP',
	'ETH',
	'USDCe',
	'DAI',
	'USDT',
	'LUSD'
];

export const stablesAllowedForDeposit: Array<TokenSymbol> = ['USDCe', 'DAI', 'USDT', 'LUSD'];
export const nonStablesAllowedForDeposit: Array<TokenSymbol> = ['OP', 'ETH'];

export const tokensAllowedForDeposit: Readable<Array<TokenSymbol>> = derived(
	[AUTOSWAP_OP, AUTOSWAP_STABLES],
	([$AUTOSWAP_OP, $AUTOSWAP_STABLES]) => {
		let allowedTokens: Array<TokenSymbol> = ['sUSD'];

		if ($AUTOSWAP_STABLES) {
			allowedTokens = allowedTokens.concat(stablesAllowedForDeposit);
		}

		if ($AUTOSWAP_OP) {
			allowedTokens = allowedTokens.concat(nonStablesAllowedForDeposit);
		}

		return allowedTokens;
	}
);
export let auxillartTokensToBeFetched: Array<TokenSymbol> = [
	'OP',
	'ETH',
	'USDCe',
	'DAI',
	'USDT',
	'LUSD'
];

export const tokensAllowedForDepositUI: Readable<Array<TokenInfo>> = derived(
	[AUTOSWAP_OP, AUTOSWAP_STABLES],
	([$AUTOSWAP_OP, $AUTOSWAP_STABLES]) => {
		let allowedTokens: Array<TokenInfo> = [{ symbol: 'sUSD', allowed: true, type: 'standard' }];

		stablesAllowedForDeposit.forEach((token) => {
			allowedTokens.push({ symbol: token, allowed: $AUTOSWAP_STABLES, type: 'stable' });
		});

		nonStablesAllowedForDeposit.forEach((token) => {
			allowedTokens.push({ symbol: token, allowed: $AUTOSWAP_OP, type: 'non-stable' });
		});

		return allowedTokens;
	}
);
